import React from 'react';

const IncreaseAwardButton = ({ show, toggleAwardsModal }) => (
  show? <button className="btn btn-secondary btn-sm" onClick={toggleAwardsModal}>
    Increase Award
  </button> : null
);

export default IncreaseAwardButton;



// WEBPACK FOOTER //
// ./project/components/wrapup/increase_award_button.jsx